import { Observable } from 'rxjs';
import { SearchParams } from '@core/models/query-params/search-params.model';
import { IListResult } from '../list-result/list-result.interface';
import { IVenueListItem } from './venue-list-item.interface';
import { ICityInfo } from './city-info.interface';

export abstract class IVenueSource {

  abstract getList(searchParams?: SearchParams): Observable<IListResult<IVenueListItem>>;
  abstract getCityByZipCode(zipCode: string): Observable<ICityInfo>;

}
